// extracted by mini-css-extract-plugin
module.exports = {"audience":"audience__3CWSc","automateAudienceRow":"automateAudienceRow__3JKsV"};